import { render, staticRenderFns } from "./OurProducts.vue?vue&type=template&id=8296909c&scoped=true&"
import script from "./OurProducts.vue?vue&type=script&lang=ts&"
export * from "./OurProducts.vue?vue&type=script&lang=ts&"
import style0 from "./OurProducts.vue?vue&type=style&index=0&id=8296909c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8296909c",
  null
  
)

export default component.exports